import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function CTA() {
  return (
    <section className="relative py-16 sm:py-24 lg:py-32 bg-black overflow-hidden">
      <div className="absolute inset-0">
        <img src="https://images.unsplash.com/photo-1604480133080-602261a680df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxneW0lMjB3b3Jrb3V0fGVufDB8fHx8MTc3ODE3ODQyN3ww&ixlib=rb-4.1.0&q=85" alt="" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-black" />
      </div>
      <div className="relative max-w-5xl mx-auto px-6 text-center reveal-scale">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-[2px] w-10 bg-red-600" />
          <span className="text-xs tracking-[0.4em] text-red-500 font-semibold">YOUR MOVE</span>
          <div className="h-[2px] w-10 bg-red-600" />
        </div>
        <h2 className="font-display text-6xl md:text-9xl leading-[0.85] tracking-tight">
          STOP WAITING.<br /><span className="text-gradient-red">START NOW.</span>
        </h2>
        <p className="mt-8 max-w-xl mx-auto text-zinc-400">Pick the plan that fits your life. Lock in $49/mo, build your family plan, or save with a paid-in-full year.</p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a href="#membership-enrollment" data-cursor="hover" className="btn-shimmer group inline-flex items-center gap-3 px-10 py-5 bg-red-600 hover:bg-red-500 rounded-md text-sm tracking-[0.3em] font-bold transition-colors">
            CHOOSE YOUR PLAN <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <a href="#contact" data-cursor="hover" className="px-10 py-5 border border-zinc-700 hover:border-red-500 hover:text-red-500 rounded-md text-sm tracking-[0.3em] font-bold transition">
            SCHEDULE A TOUR
          </a>
        </div>
      </div>
    </section>
  );
}
